import React, { Component } from 'react'
import * as Constants from '../common/Constants'
import { connect } from 'react-redux';
import LoginChild from '../login/LoginChild';

class Success extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bottomSectionToBeDisplayed: true
        };
        this.bottomSectionTimeHandler();
    }

    

    callOnOK = () => {
        this.props.setPageToBeDisplayed(Constants.LOGIN);
    }

    onCloseHandler = () => {
        this.setState({
            ...this.state,
            bottomSectionToBeDisplayed: false
        });
    };

    bottomSectionTimeHandler(){
        setInterval(()=>{
            this.setState({
                ...this.state,
                bottomSectionToBeDisplayed:false
            })
        },9000)
    }

    render() {
         return (
            <React.Fragment>
                <LoginChild showCloseBtn={this.props.showCloseBtn} isError={this.props.isError} callFromChildPage={this.props.callFromChildPage} showLoader={this.props.showLoader}
                setPassword={this.props.setPassword} />
                {this.state.bottomSectionToBeDisplayed === true ?
                    <div className="bottom-success-message" automationid="LoginSuccess_Div_Msg_1">
                        <span onClick={this.onCloseHandler} automationid="LoginSuccess_Span_Msg_2"><svg automationid="LoginSuccess_Svg_Msg_3" focusable="false" aria-hidden="true" className="icon"> <use xlink="http://www.w3.org/1999/xlink" href="#icon-close"></use></svg></span>
                        <p automationid="LoginSuccess_P_Msg_4">{this.props.successMessage1}  {this.props.successMessage2}</p>
                    </div> : null
                }
            </React.Fragment>

        )
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setPageToBeDisplayed: (pageToBeDisplayed) => dispatch({
            type: Constants.SET_PAGE_TOBE_DISPLAYED,
            payload: pageToBeDisplayed
        })
    }
}

const mapStateToProps = state => {
    return {
        successMessage1: state.successMessage1,
        successMessage2: state.successMessage2,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Success)
